type SplitHeadingProps = {
  children: string;
  as?: "h1" | "h2" | "h3";
  className?: string;
  /** When false, only the secondary phrase is italic (CTA-style). Default true. */
  italicPrimary?: boolean;
};

/**
 * Two-tone headline. Prefer `Primary|secondary` in CMS copy.
 * Falls back to splitting on the first `, ` when no pipe is present.
 */
export function SplitHeading({
  children,
  as: Tag = "h2",
  className = "",
  italicPrimary = true,
}: SplitHeadingProps) {
  const { primary, secondary } = splitTitle(children);

  return (
    <Tag className={`${italicPrimary ? "italic" : ""} ${className}`.trim()}>
      <span className="text-foreground">{primary}</span>
      {secondary ? (
        <>
          {" "}
          <em className="font-normal italic text-muted">{secondary}</em>
        </>
      ) : null}
    </Tag>
  );
}

function splitTitle(title: string): { primary: string; secondary: string } {
  const trimmed = title.trim();
  if (!trimmed) return { primary: "", secondary: "" };

  const pipe = trimmed.indexOf("|");
  if (pipe !== -1) {
    const primary = trimmed.slice(0, pipe).trim();
    const secondary = trimmed.slice(pipe + 1).trim();
    return { primary, secondary };
  }

  const comma = trimmed.indexOf(", ");
  if (comma !== -1) {
    return {
      primary: trimmed.slice(0, comma + 1).trimEnd(),
      secondary: trimmed.slice(comma + 2).trim(),
    };
  }

  return { primary: trimmed, secondary: "" };
}
